/**
 * Part 1 of COMMON_UI_I18N — composed from slices under max-lines per file.
 */

import { COMMON_UI_I18N_PART1_SLICE_A } from "./commonUiI18nPart1_sliceA";
import { COMMON_UI_I18N_PART1_SLICE_B } from "./commonUiI18nPart1_sliceB";
import { COMMON_UI_I18N_PART1_SLICE_C } from "./commonUiI18nPart1_sliceC";
import { COMMON_UI_I18N_PART1_SLICE_D } from "./commonUiI18nPart1_sliceD";

export const COMMON_UI_I18N_PART1 = {
	...COMMON_UI_I18N_PART1_SLICE_A,
	...COMMON_UI_I18N_PART1_SLICE_B,
	...COMMON_UI_I18N_PART1_SLICE_C,
	...COMMON_UI_I18N_PART1_SLICE_D,
} as const;
